module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"anthony-w-ho","short_name":"anwyho","start_url":"/","background_color":"#ecedef","theme_color":"#ffa662","display":"minimal-ui","icon":"src/images/orange.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
